export const PROPERTY_PROFILE = 'property_profile';
export const CALL_RAIL = 'call_rail';
export const REVIEWS = 'reviews';
export const VIRTUAL_ESTIMATE = 'virtual_estimate';
export const GIFT_UP = 'gift_up';
export const CHECKLISTS = 'checklists';
export const QBO = 'qbo';
export const MAILCHIMP = 'mailchimp';
export const GOOGLE_RESERVE = 'google_reserve';
export const RESPONSIBID = 'responsibid';
export const ZAPIER = 'zapier';
export const QUICKBOOKS_DESKTOP = 'quickbooks_desktop';
export const JOB_COST = 'job_cost';
export const ALEXA = 'alexa';
export const DISPATCH = 'dispatch';
export const ONLINE_BOOKING = 'online_booking';
export const FACEBOOK_BOOKING = 'facebook_booking';
export const GUSTO = 'gusto';
export const PODIUM = 'podium';
export const WISETACK = 'wisetack';
export const WEBHOOKS = 'webhooks';
export const E_COMMERCE = 'e_commerce';
export const BROADLY = 'broadly';
export const COMPANYCAM = 'companycam';
export const SIGNPOST = 'signpost';
export const SCHEDULE_ENGINE = 'schedule_engine';
export const JOB_INBOX = 'job_inbox';
export const TRADE_ACADEMY = 'trade_academy';
export const MEASUREQUICK = 'measurequick';
export const MOJIO = 'mojio';
export const VEHICLE_GPS_TRRACKING = 'vehicle_gps_tracking';
export const NICE_JOB = 'nice_job';
export const BEELINE_ROUTES = 'beeline_routes';
export const FLAT_RATE_PRICING = 'flat_rate_pricing';
export const PROFIT_RHINO = 'profit_rhino';
export const TIME_TRACKING = 'time_tracking';
export const CHAT_ON_YOUR_WEBSITE = 'chat_on_your_website';
export const API_KEY_MANAGEMENT = 'api_key_management';
export const STATE_ENABLED = 'enabled';
export const STATE_PENDING = 'pending';
export const STATE_DISABLED = 'disabled';
export const SALES_PROPOSAL = 'sales_proposal';
export const THUMBTACK = 'Thumbtack';
export const ELOCAL = 'eLocal';
export const WEBSITES = 'websites';
